module.exports = __webpack_public_path__ + "static/media/MT.32a0a629.wav";